export const TICKETS_DASHBOARD_SET_TICKETS = 'TICKETS_DASHBOARD_SET_TICKETS';
export const TICKETS_DASHBOARD_SET_PAGINATED_TICKETS = 'TICKETS_DASHBOARD_SET_PAGINATED_TICKETS';
